module.exports = __webpack_public_path__ + "img/biying_p.1c02e264.png";